import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config.js';
import { sourceParam } from '../constants/visitsSource.js';

/**
 * Hook personnalisé pour récupérer les données d'avancement annuel
 * Récupère les visites planifiées + count des visites effectuées depuis le début de l'année
 */
const useAnnualProgress = ({
  selectedProject,
  startDate,
  endDate,
  fetchWithAuth,
  // false when the client's config closes targets: no request, no 403 in the console.
  enabled = true
}) => {
  const [annualProgressData, setAnnualProgressData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnualProgress = async () => {
      // Disabled stays "loading" internally, so re-enabling never renders a loaded-but-empty frame.
      if (!enabled) {
        setAnnualProgressData(null);
        setLoading(true);
        return;
      }
      if (!selectedProject || !startDate || !endDate) {
        setAnnualProgressData(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const startDateStr = startDate.toISOString().split('T')[0];
        const endDateStr = endDate.toISOString().split('T')[0];

        const response = await fetchWithAuth(
          `${API_BASE_URL}/api/dwh/visits/${selectedProject.value}/annual-progress`
          + `?${sourceParam(selectedProject)}&startDate=${startDateStr}&endDate=${endDateStr}`
        );

        if (response.ok) {
          const data = await response.json();
          setAnnualProgressData(data);
        } else {
          console.error("Failed to fetch annual progress data");
          setError("Failed to fetch annual progress data");
          setAnnualProgressData(null);
        }
      } catch (error) {
        console.error("Error fetching annual progress:", error);
        setError(error.message);
        setAnnualProgressData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnualProgress();
  }, [enabled, selectedProject, startDate, endDate, fetchWithAuth]);

  return {
    annualProgressData,
    loading: enabled ? loading : false,
    error
  };
};

export default useAnnualProgress;
